<template>
  <a-spin :spinning="loading">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <!-- <h2 class="mr-3" v-if="!editable">Detail Asset Baru</h2>
        <h2 class="mr-3" v-else>Update Asset Baru</h2> -->
        <!-- <h2 class="mr-3">{{ editable ? 'Update Asset Baru' : 'Detail Asset Baru' }}</h2> -->
        <h2 class="mr-3">{{ role !== 'dcOwner' ? 'Update' : 'Detail' }} Asset Baru</h2>
      </div>
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <!-- aman -->
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>
          <a-button @click="changeEdittable" v-if="role !== 'dcOwner'">
            <span v-if="!editable"> <FormOutlined class="mr-2" />Edit </span>
            <span v-else> <EyeOutlined class="mr-2" />View </span>
          </a-button>
        </a-col>
        <!-- aman -->
        <a-col :span="24">
          <div>
            <h1 class="text-title">Customer & Location</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Customer</p>
                  <a-select
                    placeholder="Pilih Customer"
                    class="w-100"
                    v-model:value="selectedCustomer"
                    :disabled="!editable"
                    @change="handleChangeCustomer"
                    allow-clear
                    show-search
                    :options="customerOptions"
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Location</p>
                  <a-select
                    placeholder="Pilih Lokasi"
                    class="w-100"
                    v-model:value="selectedLocation"
                    @change="handleChangeLocation"
                    :disabled="!selectedCustomer || !editable || !dataLocation.length"
                    allow-clear
                    show-search
                    :options="locationOptions"
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Room</p>
                  <a-select
                    placeholder="Pilih Room"
                    class="w-100"
                    v-model:value="selectedRoom"
                    @change="handleChangeRoom"
                    :disabled="!selectedLocation || !editable || !dataRoom.length"
                    allow-clear
                    show-search
                    :options="roomOptions"
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <!-- aman -->
        <a-col :span="24">
          <div>
            <h1 class="text-title">Asset Information</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Asset Category</p>
                  <a-select
                    placeholder="Pilih Asset Category"
                    class="w-100"
                    v-model:value="selectedCategoriesAssets"
                    @change="handleChangeCategoriesAssets"
                    :disabled="!editable"
                    allow-clear
                    show-search
                    :options="assetSubCategoriesOptions"
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Asset Name</p>
                  <a-input
                    placeholder="Masukkan Nama Asset"
                    v-model:value="dataPayload.name"
                    :disabled="!editable"
                  ></a-input>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }"> </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Brand</p>
                  <a-select
                    placeholder="Pilih Manufacturer"
                    class="w-100"
                    v-model:value="dataPayload.manufacturerId"
                    :disabled="!editable"
                    allow-clear
                    show-search
                    :options="manufactureOptions"
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p style="text-align: left;" class="text-label">Model</p>
                <a-input
                  placeholder="Masukkan Model"
                  v-model:value="dataPayload.modelAsset"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p style="text-align: left;" class="text-label">Product No</p>
                <a-input
                  placeholder="Masukkan Product No"
                  v-model:value="dataPayload.productNumber"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p style="text-align: left;" class="text-label">Serial No</p>
                <a-input
                  placeholder="Masukkan Serial No"
                  v-model:value="dataPayload.serialNumber"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p style="text-align: left;" class="text-label">Service Tag</p>
                <a-input
                  placeholder="Masukkan Service Tag"
                  v-model:value="dataPayload.serviceTag"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p style="text-align: left;" class="text-label">Asset Tag</p>
                <a-input
                  placeholder="Masukkan Asset Tag"
                  v-model:value="dataPayload.assetTag"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col
                :xs="{ span: 24 }"
                :sm="{ span: 8 }"
                v-if="$route.path.split('/').at(1) !== 'software'"
              >
                <p style="text-align: left;" class="text-label">Rack No</p>
                <a-input
                  placeholder="Masukkan Rack No"
                  v-model:value="dataPayload.rackNumber"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col
                :xs="{ span: 24 }"
                :sm="{ span: 8 }"
                v-if="$route.path.split('/').at(1) !== 'software'"
              >
                <p style="text-align: left;" class="text-label">U No</p>
                <a-input
                  placeholder="Masukkan U No"
                  v-model:value="dataPayload.uNumber"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col
                :xs="{ span: 24 }"
                :sm="{ span: 8 }"
                v-if="$route.path.split('/').at(1) !== 'software'"
              >
                <p style="text-align: left;" class="text-label">U Size</p>
                <a-input
                  placeholder="Masukkan U Size"
                  v-model:value="dataPayload.uSize"
                  :disabled="!editable"
                ></a-input>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <!-- aman -->
        <a-col :span="24" v-if="$route.path.split('/').at(1) !== 'infrastruktur'">
          <div>
            <h1 class="text-subtitle">Procurement Information</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Tanggal Pembelian</p>

                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.procurements.purchaseDate"
                  :disabled="!editable"
                ></a-date-picker>
              </a-col>
              <a-col :xs="{ span: 12 }" :span="12">
                <p class="text-label">Nomor Pembelian</p>
                <a-input
                  placeholder="Masukkan Nomor Pembelian"
                  v-model:value="dataPayload.procurements.No"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 4 }">
                <p class="text-label">Value</p>
                <a-input
                  placeholder="Masukkan Value"
                  suffix="IDR"
                  v-model:value="formattedProcurementValue"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi</p>
                <a-input
                  placeholder="Masukkan Garansi"
                  suffix="Month(s)"
                  v-model:value="dataPayload.procurements.warranty"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi Mulai</p>
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.procurements.warrantyStart"
                  :disabled="!editable || !dataPayload.procurements.warranty"
                ></a-date-picker>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi Berakhir</p>
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="dataPayload.procurements.warrantyEnd"
                  disabled
                ></a-date-picker>
              </a-col>
              <a-col :xs="{ span: 12 }" :span="12">
                <p class="text-label">Vendor</p>
                <a-select
                  placeholder="Pilih Vendor"
                  class="w-100"
                  v-model:value="dataPayload.procurements.vendorId"
                  @change="handleChangeProcurementVendor"
                  :disabled="!editable"
                  allow-clear
                  show-search
                  :options="vendorOptions"
                  :filter-option="filterOption"
                >
                </a-select>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                <p class="text-label">Email</p>
                <a-input
                  disabled
                  placeholder="Masukkan Email"
                  v-model:value="dataPayload.procurements.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                <p class="text-label">Nomor Telepon</p>
                <a-input
                  disabled
                  placeholder="Masukkan Nomor Telepon"
                  v-model:value="dataPayload.procurements.mobileNumber"
                ></a-input>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <!-- dsni -->
        <a-col
          :span="24"
          v-if="
            $route.path.split('/').at(1) !== 'passive' &&
              $route.path.split('/').at(1) !== 'infrastruktur'
          "
        >
          <div>
            <h1 class="text-subtitle">Maintenance Information</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <a-select v-model:value="selectedMaintenanceInformation" class="w-100 mt-2 mb-2">
                  <a-select-option
                    v-for="(item, index) in dataPayload.maintenances"
                    :key="index"
                    :value="index"
                    >Maintenance Information {{ index + 1 }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 4 }">
                <a-button
                  @click="addMaintenanceInformation"
                  type="primary"
                  class="mt-2"
                  :disabled="editable ? false : true"
                  >Tambah Data Maintenance</a-button
                >
              </a-col>
            </a-row>
          </div>

          <div v-if="dataPayload.maintenances.length">
            <a-row :gutter="[24, 12]">
              <a-col
                :xs="{ span: 12 }"
                :sm="{ span: 8 }"
                v-if="$route.path.split('/').at(1) !== 'infrastruktur'"
              >
                <p class="text-label">Tanggal Kontrak</p>
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="
                    dataPayload.maintenances[selectedMaintenanceInformation].purchaseDate
                  "
                  :disabled="!editable"
                ></a-date-picker>
              </a-col>
              <a-col
                :xs="{ span: 12 }"
                :span="12"
                v-if="$route.path.split('/').at(1) !== 'infrastruktur'"
              >
                <p class="text-label">Nomor Kontrak</p>
                <a-input
                  placeholder="Masukkan Nomor Kontrak"
                  v-model:value="dataPayload.maintenances[selectedMaintenanceInformation].No"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 4 }">
                <p class="text-label">Value</p>
                <a-input
                  placeholder="Masukkan Value"
                  suffix="IDR"
                  v-model:value="formattedSelectedMaintenanceValue"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi</p>
                <a-input
                  placeholder="Masukkan Garansi"
                  suffix="Month(s)"
                  v-model:value="dataPayload.maintenances[selectedMaintenanceInformation].warranty"
                  :disabled="!editable"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi Mulai</p>
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="
                    dataPayload.maintenances[selectedMaintenanceInformation].warrantyStart
                  "
                  :disabled="!editable"
                ></a-date-picker>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                <p class="text-label">Garansi Berakhir</p>
                <a-date-picker
                  format="DD / MM / YYYY"
                  class=" w-100"
                  v-model:value="
                    dataPayload.maintenances[selectedMaintenanceInformation].warrantyEnd
                  "
                  :disabled="!editable"
                ></a-date-picker>
              </a-col>
              <a-col :xs="{ span: 12 }" :span="12">
                <p class="text-label">Vendor</p>
                <a-select
                  placeholder="Pilih Vendor"
                  class="w-100"
                  v-model:value="dataPayload.maintenances[selectedMaintenanceInformation].vendorId"
                  @change="handleChangeMaintenancesVendor"
                  :disabled="!editable"
                  allow-clear
                  show-search
                  :options="vendorOptions"
                  :filter-option="filterOption"
                >
                </a-select>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                <p class="text-label">Email</p>
                <a-input
                  disabled
                  placeholder="Masukkan Email"
                  v-model:value="dataPayload.maintenances[selectedMaintenanceInformation].email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                <p class="text-label">Nomor Telepon</p>
                <a-input
                  disabled
                  placeholder="Masukkan Nomor Telepon"
                  v-model:value="
                    dataPayload.maintenances[selectedMaintenanceInformation].mobileNumber
                  "
                ></a-input>
              </a-col>
            </a-row>
          </div>
        </a-col>

        <a-col :span="24">
          <div>
            <h1 class="text-subtitle">Description</h1>
          </div>
          <a-textarea
            v-model:value="dataPayload.description"
            :disabled="!editable"
            placeholder="Autosize height with minimum and maximum number of lines"
            :rows="10"
          />
        </a-col>
        <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
          <p style="text-align: left;" class="text-label">Note</p>
          <a-textarea
            placeholder="Masukkan Catatan"
            v-model:value="dataPayload.note"
            :rows="4"
            :disabled="!editable"
          ></a-textarea>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="$router.back()">Cancel</a-button>
              <!-- <a-button :disabled="!editable" @click="handleSubmit">Submit</a-button> -->
              <a-button
                type="primary"
                v-if="$route.path.split('/').at(1) !== 'passive'"
                :disabled="
                  !selectedCategoriesAssets ||
                    !dataPayload.name ||
                    !dataPayload.manufacturerId ||
                    !dataPayload.serialNumber ||
                    // Procurement
                    // !dataPayload.procurements.purchaseDate ||
                    // !dataPayload.procurements.No ||
                    // !dataPayload.procurements.value ||
                    // !dataPayload.procurements.warranty ||
                    // !dataPayload.procurements.warrantyStart ||
                    // !dataPayload.procurements.warrantyEnd ||
                    // !dataPayload.procurements.vendorId ||
                    // // Maintenance

                    // !dataPayload.maintenances.purchaseDate ||
                    // !dataPayload.maintenances.No ||
                    // !dataPayload.maintenances.value ||
                    // !dataPayload.maintenances.warranty ||
                    // !dataPayload.maintenances.warrantyStart ||
                    // !dataPayload.maintenances.warrantyEnd ||
                    // !dataPayload.maintenances.vendorId ||
                    !editable
                "
                @click="handleSubmit"
                >Submit</a-button
              >
              <a-button
                type="primary"
                v-else
                :disabled="
                  !selectedCategoriesAssets ||
                    !dataPayload.name ||
                    !dataPayload.manufacturerId ||
                    !dataPayload.serialNumber ||
                    // Procurement
                    // !dataPayload.procurements.purchaseDate ||
                    // !dataPayload.procurements.No ||
                    // !dataPayload.procurements.value ||
                    // !dataPayload.procurements.warranty ||
                    // !dataPayload.procurements.warrantyStart ||
                    // !dataPayload.procurements.warrantyEnd ||
                    // !dataPayload.procurements.vendorId ||
                    !editable
                "
                @click="handleSubmit"
                >Submit</a-button
              >
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </a-spin>
</template>

<script>
import { onMounted, ref, createVNode, computed, reactive, onBeforeMount, watch } from 'vue'
import { defineAsyncComponent } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import {
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LeftOutlined,
  FormOutlined,
  EyeOutlined,
} from '@ant-design/icons-vue'
import { message, Modal, notification, Form } from 'ant-design-vue'
import { getOne, remove, getAllPendings, update } from '@/services/axios/brivice-backend'
import apiClient from '@/services/axios'
import {
  getCustomers,
  getLocationByCustomerId,
  getRoomByCustomerId,
} from '../../services/axios/modc/customer'
import {
  getCategories,
  postAssets,
  getAssetsById,
  editAssetsById,
} from '../../services/axios/modc/assets'
import { getManufactures } from '../../services/axios/modc/manufacture'
import { getVendors } from '../../services/axios/modc/vendor'
import assetsFile from '@/data/modc_dump.json'
import moment from 'moment'
import { uniqueId } from 'lodash'

const columns = [
  {
    title: 'Nama Perangkat',
    dataIndex: 'device',
    key: 'device',
    slots: { customRender: 'device' },
    width: '15%',
  },
  {
    title: 'Nama Brand',
    dataIndex: 'brand',
    key: 'brand',
    slots: { customRender: 'brand' },
  },
  {
    title: 'Nomor Produk',
    dataIndex: 'productNo',
    key: 'productNo',
    slots: { customRender: 'productNo' },
  },
  {
    title: 'Nomor Serial',
    dataIndex: 'serialNo',
    key: 'serialNo',
    slots: { customRender: 'serialNo' },
  },
]
const useForm = Form.useForm
const assetsId = [
  // FACILITIES
  7 /**Elec Pan comps*/,
  8 /**UPS comps*/,
  10 /**Generator Set comps*/,
  11 /**Battery comps*/,
  12 /**Grounding */,
  13 /**Pre AC */,
  14 /**Sta AC */,
  15 /**Fire Supp comps*/,
  16 /**Fire Sup pip */,
  17 /**Fire Ext comps*/,
  18 /**CCTV comps*/,
  19 /**Door comps*/,
  20 /**ENV comps*/,
  // ACTIVE
  22 /** Access Point */,
  23 /** Firewall */,
  24 /** Router */,
  25 /** Server */,
  26 /** Switch */,
  // PASSIVE
  3 /** RACK UNIT */,
  27 /** UTP Cable */,
  28 /** UTP Patch Panel */,
  29 /** FO Patch Panel */,
  30 /** FO Cable */,
]

export default {
  components: { LeftOutlined, FormOutlined, EyeOutlined },
  setup() {
    let store = useStore()
    let route = useRoute()
    let router = useRouter()

    const assets = ref()
    // const manufactures = ref()
    const loading = ref(false)
    const catFacility = ref('Access Point')
    const facility = ref('Access-002')
    const selectedTypeofFailure = ref()
    const selectedTypeofSolving = ref()
    const selectedReparation = ref()
    const editable = ref(false)
    const componentsAssetsData = ref([])
    const componentsHardwareProcessor = ref([])
    const componentsHardwareDiskDrive = ref([])
    const componentsHardwareMemory = ref([])
    const options = ref([])
    const value1 = ref('')
    const selectedMaintenanceInformation = ref(0)
    const addMaintenanceInformation = () => {
      dataPayload.value.maintenances.push({
        vendorId: null,
        email: '',
        mobileNumber: null,
        No: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      })
    }

    // CUSTOMER
    const selectedCustomer = ref()
    const dataCustomers = ref([])
    const selectedLocation = ref()
    const dataLocation = ref([])
    const selectedRoom = ref()
    const dataRoom = ref([])

    // CATEGORIES
    const dataCategoriesAssets = ref([])
    const selectedCategoriesAssets = ref()

    // BRAND/MANUFACTURE
    const dataManufatures = ref([])
    const selectedManufatures = ref()

    // VENDORS
    const dataVendors = ref([])
    const selectedVendors = ref()
    const selectedVendors2 = ref()

    const dataTypeofFailure = [
      'Hardware Failure',
      'Software Failure',
      'System Failure',
      'Part Failure',
      'Broken Part',
      'Other',
    ]
    const capacityOption = [
      '64 MB',
      '128 MB',
      '256 MB',
      '512 MB',
      '1 GB',
      '2 GB',
      '4 GB',
      '8 GB',
      '16 GB',
      '32 GB',
      '64 GB',
      '128 GB',
      '256 GB',
      '512 GB',
      '1 TB',
      '2 TB',
      '4 TB',
      '8 TB',
      '16 TB',
      '32 TB',
      '64 TB',
      '128 TB',
      '256 TB',
      '512 TB',
    ]
    const utpType = ['cat3', 'cat4', 'cat5', 'cat5e', 'cat6', 'cat6a', 'cat7', 'cat7a']
    const connectionType = [
      'Point to Point',
      'Point to Multiple Point',
      'Multiple Point to Multiple Point',
      'Switch Hub to Client',
    ]
    const foType = ['OM2', 'OM3', 'OM4', 'Single Mode', 'Multi Mode']
    const foConnectionType = ['Backbone', 'Horizontal', 'Patch Cord']

    const dataSoftwareType = [
      'Antivirus',
      'Database System',
      'Enterprise',
      'Graphics',
      'Operating System',
      'Spreadsheet',
      'Word Processors',
    ]

    const dataTypeofSolving = ['Reparation', 'Part Replacement', 'Reconfiguration']
    const dataReparation = ['Minor', 'Major', 'Overhaul', 'Other']
    const addTroubleshootDetail = () => {
      componentsAssetsData.value.push({
        _id: uniqueId('tbs-'),
        name: '',
        quantity: '',
        location: '',
      })
    }
    const deleteTroubleshootDetail = id => {
      componentsAssetsData.value = componentsAssetsData.value.filter(trb => trb._id !== id)
    }
    const addHardwareProcessor = () => {
      componentsHardwareProcessor.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareProcessor = id => {
      componentsHardwareProcessor.value = componentsHardwareProcessor.value.filter(
        trb => trb._id !== id,
      )
    }
    const formattedSelectedMaintenanceValue = computed({
      get() {
        const index = selectedMaintenanceInformation.value
        // Pastikan ada item yang dipilih untuk menghindari error
        if (index === null || index === undefined || !dataPayload.value.maintenances[index]) {
          return ''
        }

        const value = dataPayload.value.maintenances[index].value
        if (value === null || value === undefined) {
          return ''
        }

        // Format angka ke string dengan pemisah ribuan
        return new Intl.NumberFormat('id-ID').format(value)
      },
      set(newValue) {
        const index = selectedMaintenanceInformation.value
        // Pastikan ada item yang dipilih sebelum mengubah nilainya
        if (index === null || index === undefined) {
          return
        }

        // Ubah string berformat kembali ke angka
        const newNumber = parseInt(newValue.replace(/[^0-9]/g, ''), 10)

        // Update data asli di dalam array pada index yang benar
        dataPayload.value.maintenances[index].value = isNaN(newNumber) ? 0 : newNumber
      },
    })

    const addHardwareDiskDrive = () => {
      componentsHardwareDiskDrive.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareDiskDrive = id => {
      componentsHardwareDiskDrive.value = componentsHardwareDiskDrive.value.filter(
        trb => trb._id !== id,
      )
    }
    const role = ref('')
    const addHardwareMemory = () => {
      componentsHardwareMemory.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareMemory = id => {
      componentsHardwareMemory.value = componentsHardwareMemory.value.filter(trb => trb._id !== id)
    }
    onBeforeMount(() => {
      const storedUserData = localStorage.getItem('userData')
      const userData = JSON.parse(storedUserData)
      role.value = userData.user.role
      fetchInitialData()
    })

    const dataPayload = ref({
      wifiName: null,
      availablePort: null,
      workingPort: null,
      deadPort: null,
      ipAdress: null,
      subnetMask: null,
      gateway: null,
      totalPort: null,
      systemName: null,
      hostName: null,
      domainRole: null,
      dns: null,
      os: null,
      softwareName: null,
      softwareVersion: null,
      accessType: null,
      airFlow: null,
      coolingDesign: null,
      coolingType: null,
      coolingCapacity: null,
      inputPowerKw: null,
      panelType: null,
      transferSwitch: null,
      phaseType: null,
      sensorType: null,
      supressType: null,
      fillDate: null,
      expireDate: null,
      extenguisherType: null,
      kva: null,
      kw: null,
      machineType: null,
      systemTrigger: null,
      model: null,
      formFactor: null,
      battery: null,
      height: null,
      width: null,
      depth: null,
      weight: null,
      backupKw: null,
      backupKva: null,
      backupDuration: null,
      inputKw: null,
      inputKva: null,
      outputKw: null,
      outputKva: null,
      batteryType: null,
      voltage: null,
      cells: null,
      controllerStatus: null,
      utpType: null,
      node: null,
      core: null,
      connectionType: null,
      patch: null,
      cableManagement: null,
      rackUnit: null,
      crossConnection: null,
      foType: null,
      softwareType: null,
      version: null,
      customerId: null,
      locationId: null,
      roomId: null,
      assetSubCategoryId: null,
      manufacturerId: null,
      vendorId: null,
      name: null,
      modelAsset: null,
      productNumber: null,
      serialNumber: null,
      serviceTag: null,
      assetTag: null,
      rackNumber: null,
      uNumber: null,
      uSize: null,
      status: null,
      note: null,
      diskDrives: [
        // {
        //   model: 'Disk Drive Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      memories: [
        // {
        //   model: 'Memory Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      processors: [
        // {
        //   model: 'Processor Model 1',
        //   speed: '3.6 GHz',
        //   threads: 6,
        //   cores: 6,
        // },
      ],
      components: [
        // {
        //   model: 'Processor Model 1',
        //   speed: '3.6 GHz',
        //   threads: 6,
        //   cores: 6,
        // },
      ],
      procurements: {
        vendorId: null,
        email: null,
        mobileNumber: null,
        No: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      },
      maintenances: [
        {
          vendorId: null,
          email: null,
          mobileNumber: null,
          No: null,
          value: null,
          warranty: null,
          warrantyStart: null,
          warrantyEnd: null,
        },
      ],
    })
    const rulesPayload = ref({
      wifiName: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      availablePort: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      workingPort: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      deadPort: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      ipAdress: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      subnetMask: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      gateway: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      totalPort: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      systemName: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      hostName: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      domainRole: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      dns: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      os: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      softwareName: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      softwareVersion: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      accessType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      airFlow: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      coolingDesign: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      coolingType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      coolingCapacity: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      inputPowerKw: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      panelType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      transferSwitch: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      phaseType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      sensorType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      supressType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      fillDate: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      expireDate: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      extenguisherType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      kva: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      kw: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      machineType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      systemTrigger: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      model: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      formFactor: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      battery: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      height: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      width: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      depth: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      weight: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      backupKw: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      backupKva: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      backupDuration: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      inputKw: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      inputKva: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      outputKw: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      outputKva: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      batteryType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      voltage: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      cells: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      controllerStatus: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      utpType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      node: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      core: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      connectionType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      patch: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      cableManagement: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      rackUnit: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      crossConnection: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      foType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      softwareType: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      version: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      customerId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      locationId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      roomId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      assetSubCategoryId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      manufacturerId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      vendorId: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      name: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      modelAsset: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      productNumber: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      serialNumber: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      serviceTag: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      assetTag: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      rackNumber: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      uNumber: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      uSize: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      status: [
        {
          required: true,
          message: 'Please input name',
        },
      ],
      diskDrives: [
        // {
        //   model: 'Disk Drive Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      memories: [
        // {
        //   model: 'Memory Model 1',
        //   serialNumber: 'SN1234567890A',
        //   capacity: '128 GB',
        // },
      ],
      processors: [
        // {
        //   model: 'Processor Model 1',
        //   speed: '3.6 GHz',
        //   threads: 6,
        //   cores: 6,
        // },
      ],
      components: [
        // {
        //   model: 'Processor Model 1',
        //   speed: '3.6 GHz',
        //   threads: 6,
        //   cores: 6,
        // },
      ],
      procurements: {
        vendorId: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        email: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        mobileNumber: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        No: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        Date: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        value: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warranty: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warrantyStart: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warrantyEnd: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
      },
      maintenances: {
        vendorId: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        email: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        mobileNumber: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        No: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        Date: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        value: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warranty: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warrantyStart: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
        warrantyEnd: [
          {
            required: true,
            message: 'Please input name',
          },
        ],
      },
    })
    watch(
      [
        () => dataPayload.value.procurements,
        () => dataPayload.value.maintenances[selectedMaintenanceInformation.value],
      ],
      ([newProcurements, newMaintenances], [oldProcurements, oldMaintenances]) => {

        // Logika untuk procurements
        if (moment.isMoment(newProcurements.warrantyStart)) {
          let newWarrantyEnd = newProcurements.warrantyStart
            .clone()
            .add(newProcurements.warranty, 'months')
          if (!newWarrantyEnd.isSame(oldProcurements.warrantyEnd)) {
            newProcurements.warrantyEnd = newWarrantyEnd
          }
        } else {
        }

        // Logika untuk maintenances
        if (newMaintenances && moment.isMoment(newMaintenances.warrantyStart)) {
          let newWarrantyEnd = newMaintenances.warrantyStart
            .clone()
            .add(newMaintenances.warranty, 'months')
          if (!newWarrantyEnd.isSame(oldMaintenances ? oldMaintenances.warrantyEnd : null)) {
            newMaintenances.warrantyEnd = newWarrantyEnd
          }
        } else {
        }
      },
      { deep: true },
    )

    const customerOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Customer' }

      return [
        defaultOption,
        ...dataCustomers.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const locationOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Lokasi' }

      return [
        defaultOption,
        ...dataLocation.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const vendorOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Vendor' }

      return [
        defaultOption,
        ...dataVendors.value.map(item => ({
          value: item.id,
          label: item.name,
          ...item,
        })),
      ]
    })
    const roomOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Ruangan' }

      return [
        defaultOption,
        ...dataRoom.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const manufactureOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Ruangan' }

      return [
        defaultOption,
        ...dataManufatures.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const assetSubCategoriesOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Asset Category' }

      return [
        defaultOption,
        ...dataCategoriesAssets.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const fetchInitialData = async () => {
      loading.value = true
      const customers = await getCustomers()
      dataCustomers.value = customers.customer.map(e => ({ name: e.name, id: e.id }))

      const categories = await getCategories()
      let catAssets
      switch (route.path.split('/').at(1)) {
        case 'active':
          catAssets = 1
          break
        case 'passive':
          catAssets = 2
          break
        case 'facilities':
          catAssets = 3
          break
        case 'software':
          catAssets = 4
          break
        case 'infrastruktur':
          catAssets = 5
          break
        case 'monitoring':
          catAssets = 6
          break

        default:
          break
      }
      dataCategoriesAssets.value = categories.categories.map(e => ({ name: e.name, id: e.id }))
      const currentRoute = route.path
        .split('/')
        .at(-2)
        .split('_')
        .join(' ')
        .split(' ')
      let strRouteCapital = ''
      currentRoute.forEach(txt => {
        strRouteCapital += txt.split('')[0].toUpperCase() + txt.slice(1) + ' '
      })

      const manufactures = await getManufactures()
      dataManufatures.value = manufactures.manufacturers.map(e => ({ name: e.name, id: e.id }))

      const vendors = await getVendors()
      dataVendors.value = vendors.vendor.map(e => ({ name: e.name, id: e.id, ...e }))
      const { assets } = await getAssetsById(route.params.id)
      const {
        AssetSubCategory,
        Customer,
        HardwareInformation,
        Location,
        Manufacturer,
        Room,
        TechnicalActiveDevice,
        TechnicalFacility,
        TechnicalPassiveDevice,
        TechnicalSoftware,
        ProcurementInformation,
        MaintenanceInformations,
        Components,
        ...rest
      } = assets
      // console.log(
      //   AssetSubCategory,
      //   Customer,
      //   HardwareInformation,
      //   Location,
      //   Manufacturer,
      //   Room,
      //   TechnicalActiveDevice,
      //   TechnicalFacility,
      //   TechnicalPassiveDevice,
      //   TechnicalSoftware,
      //   Components,
      //   '<<<<<CATEGORIES',
      // )
      // console.log(assets, 'yang inkah')
      selectedCustomer.value = Customer ? Customer.id : null
      handleChangeCustomer(Customer ? Customer.id : null)
      selectedLocation.value = Location ? Location.id : null
      handleChangeLocation(Location ? Location.id : null)
      selectedRoom.value = Room ? Room.id : null
      selectedCategoriesAssets.value = AssetSubCategory ? +AssetSubCategory.id : null
      // console.log(selectedCategoriesAssets.value, 'cekinidahhh')
      const vendorProcurement = dataVendors.value.find(
        data => data.id == ProcurementInformation.vendorId,
      )

      selectedManufatures.value = Manufacturer ? Manufacturer.id : null
      componentsAssetsData.value = Components
      console.log(ProcurementInformation, 'cekinibroooo')
      dataPayload.value = {
        ...dataPayload.value,
        customerId: String(Customer ? Customer.id : null),
        locationId: String(Location ? Location.id : null),
        roomId: String(Room ? Room.id : null),
        assetSubCategoryId: String(AssetSubCategory ? AssetSubCategory.id : null),
        name: rest.name,
        manufacturerId: Manufacturer ? Manufacturer.id : null,
        modelAsset: rest.model,
        productNumber: rest.productNumber,
        serialNumber: rest.serialNumber,
        serviceTag: rest.serviceTag,
        assetTag: rest.assetTag,
        rackNumber: rest.rackNumber,
        uNumber: rest.uNumber,
        uSize: rest.uSize,
        description: rest.description,
        note: rest.note,
        procurements: {
          ...dataPayload.value.procurements,
          ...ProcurementInformation,
          email: vendorProcurement.email,
          mobileNumber: vendorProcurement.mobileNumber,
        },
        maintenances: MaintenanceInformations
          ? MaintenanceInformations
          : [
              {
                vendorId: null,
                email: null,
                mobileNumber: null,
                No: null,
                Date: null,
                value: null,
                warranty: null,
                warrantyStart: null,
                warrantyEnd: null,
              },
            ],

        ...TechnicalActiveDevice,
        ...TechnicalFacility,
        ...TechnicalPassiveDevice,
        ...TechnicalSoftware,
        ...Components,
      }
      console.log(dataPayload.value, 'cekinipayloadearly')
      loading.value = false
    }
    const handleChangeCustomer = async e => {
      const location = await getLocationByCustomerId(e)
      dataLocation.value = location.locations.map(e => ({ name: e.name, id: e.id }))
      dataPayload.value.customerId = e
    }
    const handleChangeLocation = async e => {
      const room = await getRoomByCustomerId(selectedCustomer.value, e)
      // console.log(room)
      dataRoom.value = room.rooms.map(e => ({ name: e.name, id: e.id }))
      dataPayload.value.locationId = e
    }
    const handleChangeRoom = async e => {
      dataPayload.value.roomId = e
    }
    const handleChangeCategoriesAssets = async e => {
      dataPayload.value.assetSubCategoryId = e
    }
    const handleChangeProcurementVendor = async e => {
      console.log(e, '??')
      if (!e) {
        dataPayload.value.procurements.email = ''
        dataPayload.value.procurements.mobileNumber = ''
      } else {
        const vendorProcurement = dataVendors.value.find(data => data.id == e)
        dataPayload.value.procurements.email = vendorProcurement.email
          ? vendorProcurement.email
          : ''
        dataPayload.value.procurements.mobileNumber = vendorProcurement.mobileNumber
          ? vendorProcurement.mobileNumber
          : ''
      }
    }
    const handleChangeMaintenancesVendor = async e => {
      if (!e) {
        dataPayload.value.maintenances.email = ''
        dataPayload.value.maintenances.mobileNumber = ''
      } else {
        const vendorMaintenance = dataVendors.value.find(data => data.id == e)
        dataPayload.value.maintenances.email = vendorMaintenance.email
          ? vendorMaintenance.email
          : ''
        dataPayload.value.maintenances.mobileNumber = vendorMaintenance.mobileNumber
          ? vendorMaintenance.mobileNumber
          : ''
      }
    }

    const changeEdittable = () => {
      loading.value = true
      editable.value = !editable.value
      loading.value = false
    }
    const handleSubmit = async () => {
      dataPayload.value.components = componentsAssetsData.value
      const payload = dataPayload.value

      console.log(dataCategoriesAssets.value, 'inilistCategoryasset')
      console.log(selectedCategoriesAssets.value, 'iniselecetd')
      const routeCat = dataCategoriesAssets.value.find(
        val => val.id == selectedCategoriesAssets.value,
      )
      // console.log(routeCat, 'inirutekucingnya')
      // let routeName
      // switch (routeCat.name) {
      //   case 'Electrical Panel':
      //     routeName = 'electrical_panel'
      //     break
      //   case 'UPS':
      //     routeName = 'ups'
      //     break
      //   case 'Generator Set':
      //     routeName = 'generator_set'
      //     break
      //   case 'Battery':
      //     routeName = 'battery'
      //     break
      //   case 'Precision AC':
      //     routeName = 'precision_ac'
      //     break
      //   case 'Standard AC':
      //     routeName = 'standard_ac'
      //     break
      //   case 'Fire Suppr. Gas & Cylinder':
      //     routeName = 'fire_suppresion'
      //     break
      //   case 'Fire Suppr. Piping':
      //     routeName = 'fire_piping'
      //     break
      //   case 'Fire Extinguisher':
      //     routeName = 'fire_extinguisher'
      //     break
      //   case 'Security - CCTV':
      //     routeName = 'cctv'
      //     break
      //   case 'Security - Access Door':
      //     routeName = 'access_door'
      //     break
      //   case 'Environment & Facility':
      //     routeName = 'env_monitoring'
      //     break
      //   case 'Access Point':
      //     routeName = 'access_point'
      //     break
      //   case 'Firewall':
      //     routeName = 'firewall'
      //     break
      //   case 'Router':
      //     routeName = 'router'
      //     break
      //   case 'Server':
      //     routeName = 'serve'
      //     break
      //   case 'Switch':
      //     routeName = 'switch'
      //     break
      //   case 'Storage':
      //     routeName = 'storage'
      //     break
      //   case 'UTP Cable':
      //     routeName = 'utp_cable'
      //     break
      //   case 'UTP Patch Panel':
      //     routeName = 'utp_patch_panel'
      //     break
      //   case 'FO Patch Panel':
      //     routeName = 'fo_patch_panel'
      //     break
      //   case 'Rack Unit':
      //     routeName = 'rack'
      //     break
      //   case 'Software':
      //     routeName = 'list'
      //     break
      //   case 'Partition, Ceiling, & Door':
      //     routeName = 'list'
      //     break
      //   case 'Raised Floor & Ramp':
      //     routeName = 'list'
      //     break
      //   case 'Interior & Furniture':
      //     routeName = 'list'
      //     break
      //   case 'Data Cabling':
      //     routeName = 'list'
      //     break
      //   case 'Electrical Cabling':
      //     routeName = 'list'
      //     break
      //   case 'Electrical Power Source':
      //     routeName = 'list'
      //     break
      //   case 'Grounding System':
      //     routeName = 'list'
      //     break
      //   default:
      //     break
      // }
      // console.log('submit?')

      console.log(payload, 'iniwaktuupdate')
      const res = await editAssetsById(route.params.id, payload)
      if (res) {
        notification.success({
          message: 'Berhasil Update',
          description: 'Data Asset Berhasil Diupdate',
        })
      } else {
        notification.error({
          message: 'Server Error',
          description: 'Internal Server Error',
        })
      }
      router.push('/' + route.path.split('/').at(1) + '/' + selectedCategoriesAssets.value)
      console.log(res, '<<<<PAYLOAD')
    }
    const formattedProcurementValue = computed({
      // GET: function ini dijalankan saat nilai ditampilkan
      get() {
        const value = dataPayload.value.procurements.value
        if (value === null || value === undefined) {
          return ''
        }
        // Format angka dengan pemisah ribuan (,)
        return new Intl.NumberFormat('id-ID').format(value)
      },
      // SET: function ini dijalankan saat pengguna mengetik di input
      set(newValue) {
        // Hapus semua karakter yang bukan angka (misal: koma, titik, spasi)
        const newNumber = parseInt(newValue.replace(/[^0-9]/g, ''), 10)

        // Jika hasilnya angka yang valid, update data asli. Jika tidak, set ke 0.
        dataPayload.value.procurements.value = isNaN(newNumber) ? 0 : newNumber
      },
    })
    // const options2 = ref(['data 1', 'data 2'])
    return {
      manufactureOptions,
      roomOptions,
      filterOption,
      customerOptions,
      locationOptions,
      vendorOptions,
      assetSubCategoriesOptions,
      role,
      addMaintenanceInformation,
      selectedMaintenanceInformation,
      options,
      // options2,
      value1,
      // assetsFile,
      // assets,
      // getAssets,
      // getManufacture,
      // manufactures,
      loading,
      columns,
      // detail troubleshoot
      facility,
      catFacility,
      componentsAssetsData,
      componentsHardwareProcessor,
      componentsHardwareDiskDrive,
      componentsHardwareMemory,
      // Last Section
      dataTypeofFailure,
      dataTypeofSolving,
      dataReparation,
      selectedReparation,
      selectedTypeofFailure,
      selectedTypeofSolving,
      editable,

      // getCurrentDate,
      changeEdittable,

      addTroubleshootDetail,
      deleteTroubleshootDetail,
      addHardwareProcessor,
      deleteHardwareProcessor,
      addHardwareDiskDrive,
      deleteHardwareDiskDrive,
      addHardwareMemory,
      deleteHardwareMemory,
      handleSubmit,

      // DATA CUSTOMER
      selectedCustomer,
      dataCustomers,
      selectedLocation,
      dataLocation,
      selectedRoom,
      dataRoom,
      // FUNCTION
      handleChangeCustomer,
      handleChangeLocation,
      handleChangeRoom,
      handleChangeCategoriesAssets,
      handleChangeProcurementVendor,
      handleChangeMaintenancesVendor,
      // DATA CUSTOMER

      // CATEGORY ASSETS
      dataCategoriesAssets,
      selectedCategoriesAssets,
      // CATEGORY ASSETS

      // MANUFACTURE
      dataManufatures,
      selectedManufatures,
      // MANUFACTURE

      // VENDORS
      dataVendors,
      selectedVendors,
      selectedVendors2,
      // VENDORS

      // CAPACITY
      capacityOption,
      // CAPACITY

      // PASSIVE
      utpType,
      connectionType,
      foType,
      foConnectionType,
      // PASSIVE

      // SOFTWARE
      dataSoftwareType,
      // SOFTWARE

      // DATA PAYLOAD
      dataPayload,
      // validateInfos,
      // DATA PAYLOAD
      // dataSource,
      formattedSelectedMaintenanceValue,
      formattedProcurementValue,
    }
  },
}
</script>
<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

// . {
//   background-color: white !important;
//   input {
//     background-color: white !important;
//   }
// }
// :global(.ant-select-.ant-select:not(.ant-select-customize-input)) {
//   :global(.ant-select-selector) {
//     background-color: white !important;
//   }
// }
// .ant-input .ant- {
//   background-color: #ffffff !important;
// }
.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;

    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
